<template>
    <front-layout title="Contactos">
        <div class="fixed top-0 left-0 w-full min-h-full block bg-opacity-80 z-50 bg-gray-900 pointer-events-none" v-if="showReplyForm"></div>
            <Map class="relative z-10 pt-40"/>

            <div class="container mx-auto px-4 py-20 text-lg">
                <div class="lg:flex items-start space-x-4">
                    <div class="flex-1">
                        <div class="lg:flex items-center space-x-2">
                            <button v-if="$page.props.user && $page.props.user.is_admin == 1" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="enableEdit = true">Editar conteúdo</button>

                            <button v-if="$page.props.user && $page.props.user.is_admin == 1 && enableEdit == true" class="mb-4 text-cyan-500 px-2 border border-cyan-500 rounded-full text-sm block" @click.prevent="updateSettings">Guardar</button>
                        </div>

                        <div v-if="$page.props.user && enableEdit == true" class="bg-white inline-block p-2 rounded-lg">

                            <div class="lg:flex items-start space-x-4">
                                <div class="flex-1">
                                    <h3 class="font-bold uppercase">Onde Estamos</h3>
                                    <address contenteditable @focusout="updateText" v-html="morada_pessoalform" id="morada_pessoalform"></address>


                                    <h3 class="font-bold uppercase mt-4">Contactos</h3>
                                    <div contenteditable @focusout="updateText" v-html="tel_pessoalform" id="tel_pessoalform"></div>

                                    <div contenteditable @focusout="updateText" v-html="tlm_pessoalform" id="tlm_pessoalform"></div>

                                    <div contenteditable @focusout="updateText" v-html="email_pessoalform" id="email_pessoalform"></div>

                                    <h3 class="font-bold uppercase mt-4">Siga-nos</h3>
                                    <div class="flex flex-col">
                                        <div class="flex items-center space-x-2">
                                            <p class="font-bold">facebook url:</p>
                                            <div contenteditable @focusout="updateText" v-html="facebook_url" id="facebook_url"></div>
                                        </div>
                                        

                                        <div class="flex items-center space-x-2">
                                            <p class="font-bold">linkedin url:</p>
                                            <div contenteditable @focusout="updateText" v-html="linkedin_url" id="linkedin_url"></div>
                                            
                                        </div>
                                        

                                        <div class="flex items-center space-x-2">
                                            <p class="font-bold">youtube url:</p>
                                            <div contenteditable @focusout="updateText" v-html="youtube_url" id="youtube_url"></div>
                                        </div>
                                        

                                        <div class="flex items-center space-x-2">
                                            <p class="font-bold">instagram url:</p>
                                            <div contenteditable @focusout="updateText" v-html="instagram_url" id="instagram_url">
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex-1">
                                        <h3 class="font-bold uppercase">Horários</h3>
                                        <div contenteditable @focusout="updateText" v-html="horario_funcionamento_pessoalform" id="horario_funcionamento_pessoalform"></div>

                                        <div contenteditable @focusout="updateText" v-html="horario_inscricoes_pessoalform" id="horario_inscricoes_pessoalform"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-else>
                            <div class="lg:flex items-start lg:space-x-8">
                                <div class="flex-2">
                                    <h3 class="font-bold uppercase">Onde Estamos</h3>
                                    <address v-html="morada_pessoalform"></address>
                                    <h3 class="font-bold uppercase mt-4">Contactos</h3>
                                    <div v-html="tel_pessoalform"></div>
                                    <div v-html="tlm_pessoalform"></div>
                                    <div v-html="email_pessoalform"></div>
                                    <h3 class="font-bold uppercase mt-4">Siga-nos</h3>
                                    <div class="flex flex-row justify-start space-x-2">
                                        <a :href="facebook_url" target="_blank"><icon name="facebook" class="w-8 h-8 hover:shadow-lg rounded-full p-1 border border-gray-900 iconfx transition" /></a>
                                        <a :href="linkedin_url" target="_blank"><icon name="linkedin" class="w-8 h-8 hover:shadow-lg rounded-full p-1 border border-gray-900 iconfx transition" /></a>
                                        <a :href="youtube_url" target="_blank"><icon name="youtube" class="w-8 h-8 hover:shadow-lg rounded-full p-1 border border-gray-900 iconfx transition" /></a>
                                        <a :href="instagram_url" target="_blank"><icon name="instagram" class="w-8 h-8 hover:shadow-lg rounded-full p-1 border border-gray-900 iconfx transition" /></a>
                                    </div>
                                </div>
                                <div class="flex-1 mt-4 lg:mt-0">
                                    <h3 class="font-bold uppercase">Horários</h3>
                                    <h5 class="text-sm font-bold underline mt-2">Funcionamento</h5>
                                    <div v-html="horario_funcionamento_pessoalform"></div>
                                    <h5 class="text-sm font-bold mt-4 underline">Inscrições/Entrevistas</h5>
                                    <div v-html="horario_inscricoes_pessoalform"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="text-center">
                            <jet-button @click.prevent="showReplyForm = true" class="bg-transparent hover:bg-transparent active:bg-transparent mt-8 group text-lg text-violet-500 font-bold flex items-center uppercase py-2 px-8 rounded-full border border-violet-500 inline-flex relative">Formulário de Contacto <icon name="arrow-right" class="w-4 h-4 absolute opacity-0 transition-all right-4 group-hover:opacity-100 group-hover:right-2" /></jet-button>
                        </div>

                         <!-- form -->
                        <div class="border fixed top-0 right-0 bg-white p-6 shadow-xl z-50 overflow-y-auto transition-all h-full w-full lg:w-1/2" :class="showReplyForm ? 'right-0' : '-right-[100vw]'">
                              
                            <h3 class="font-bold text-xl">Formulário de Contacto</h3>
                            <p class="text-sm">Os campos assinalados com (*) são de preenchimento obrigatório.</p>

                        
                            <form @submitted="sendMessage" class="w-full border-t pt-8 overflow-y-auto">
                                <!-- Title -->
                                <div>
                                    <div class="flex flex-row space-x-2">
                                        <jet-label for="nome" value="Nome Completo *" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.nome" />
                                    </div>
                                   
                                    <jet-input type="text" v-model="form.nome" class="w-full"/>
                                </div>

                                 <!-- Email -->
                                <div class="w-full mt-4">
                                    <div class="flex flex-row space-x-2">
                                        <jet-label for="email" value="Email *" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.email" />
                                    </div>
                                    <jet-input type="text" v-model="form.email" class="w-full"/>
                                </div>

                                <div class="w-full mt-4">
                                    <!-- Assunto -->
                                    <div class="w-full">
                                        <div class="flex flex-row space-x-2">
                                            <jet-label for="assunto" value="Assunto *" class="font-bold text-xs" />
                                            <jet-input-error :message="form.errors.assunto" />
                                        </div>
                                        <jet-input type="text" v-model="form.assunto" class="w-full"/>
                                        
                                    </div>
                                </div>

                                <input type="hidden" v-model="pfield">

                                     <!-- Mensagem -->
                                <div class="mt-4">
                                    <div class="flex flex-row space-x-2">
                                        <jet-label for="msg" value="Mensagem *" class="font-bold text-xs" />
                                        <jet-input-error :message="form.errors.msg" />
                                    </div>
                                    <text-area-input v-model="form.msg" rows="6" class="w-full"></text-area-input>
                                </div>
                            </form>
                       

                            <div class="lg:mt-8 lg:flex items-center">
                                <div>
                                    <jet-checkbox v-model="form.rgpd" class="mr-2" value=""></jet-checkbox> Li e aceito a <a :href="route('pol_privacidade')" class="text-violet-500 underline">Política de Privacidade *</a>
                                    <jet-input-error :message="form.errors.rgpd" />

                                </div>
                                <div class="flex flex-row justify-end flex-1">
                                    <jet-secondary-button @click="cancel">Cancelar</jet-secondary-button>

                                    <jet-button @click.prevent="sendMessage" class="ml-2 bg-violet-500 hover:bg-violet-600">Enviar</jet-button>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
        </div>
    </front-layout>
</template>

<style>
    .iconfx:hover {
        transform: rotate(5deg);
    }
</style>

<script>
    import { defineComponent } from 'vue'
    import FrontLayout from '@/Layouts/FrontLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Icon from '@/Jetstream/Icon.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'
    import JetModal from '@/Jetstream/Modal.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetDialogModal from '@/Jetstream/DialogModal.vue'
    import JetFormMain from '@/Jetstream/MainForm.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetInputError from '@/Jetstream/InputError.vue'
    import TextAreaInput from '@/Jetstream/TextAreaInput.vue'
    import JetCheckbox from '@/Jetstream/Checkbox.vue'
    import SelectInput from '@/Components/SelectInput'
    import Map from '@/Components/Map'

    export default defineComponent({
        components: {
            Head,
            Link,
            FrontLayout,
            Icon,
            JetButton,
            JetModal,
            JetDialogModal,
            JetInput,
            JetSecondaryButton,
            JetFormMain,
            JetLabel,
            JetInputError,
            TextAreaInput,
            SelectInput,
            JetCheckbox,
            Map
        },
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            morada_pessoalform: String, 
            tel_pessoalform: String,
            tlm_pessoalform: String,
            email_pessoalform: String, 
            horario_funcionamento_pessoalform: String,
            horario_inscricoes_pessoalform: String,
            facebook_url: String,
            linkedin_url: String, 
            youtube_url: String,
            instagram_url: String
        },
        data() {
            return {
                showReplyForm: false,
                pfield: '',
                form: this.$inertia.form({
                    nome: '',
                    email: '',
                    assunto: '',
                    msg: '',
                    rgpd: ''
                }),
                enableEdit: false,
                settings: this.$inertia.form({
                    setting: '',
                    content: '',
                    route: '',
                })
            }
        },
        methods: {
            sendMessage() {
                if(this.pfield == ''){
                    this.form.post(route('contact.message'), {
                        preserveScroll: true,
                        onSuccess: () => (
                            this.form.reset(),
                            this.showReplyForm = false
                        ),
                    }); 
                }
            },
            cancel() {
                this.form.reset()
                this.showReplyForm = false
            },
            updateText(e) {
                this.settings.setting = e.target.id
                this.settings.content = e.target.innerHTML,
                this.settings.route = this.route().current()
            },
            updateSettings(e) {
                if(this.settings.setting != '' && this.settings.content != '' & this.settings.route != '') {
                    this.settings.post(route('update.settings'), {
                        preserveState: false,
                        preserveScroll: true,
                        onSuccess: () => {
                            this.form.reset(),
                            this.$page.props.flash.success = 'Página atualizada'
                        }, 
                    })
                }
            },
        },
    })
</script>
